export const BASE_PATH_WITH_TXA = `/account/:txaId`;

export const routeListViewFragments = {
  INVOICES: 'invoices',
  REFUNDS: 'refunds',
  SUBSCRIPTIONS: 'subscriptions',
  CUSTOMER_ADDRESSES: 'customers',
  CUSTOMER_ADDRESS_DETAIL: 'customer-addresses',
  QUOTES: 'quotes',
  INTERNAL_USAGE_SUBSCRIPTIONS: 'internal-usage-subscriptions',
  DEAL_REGISTRATIONS: 'deal-registrations',
};

export const routeWithNoListViewFragments = {
  CLOUD_SITE_PATH: 'cloud-sites',
  BILLING_PROFILES: 'billing-profiles',
};

export const routeFragments = {
  ...routeListViewFragments,
  ...routeWithNoListViewFragments,
  DETAILS: 'details',
  CATALOG: 'catalog',
  SEARCH: 'search',
  HOME: 'home',
  DETAILS_ACCOUNT_BALANCE: 'details/account-balance',
  EMAIL_DETAILS_PATH: 'emails',
  ORDER_DETAILS_PATH: 'orders',
  IMPORT_SUBSCRIPTION_PAGE: 'import-subscriptions',
  CART: 'cart',
  CREDIT_DETAILS_PATH: 'credit-details',
  ORDER: 'order',
  SETTINGS: 'settings',
  ORGANISATIONS: 'organisations',
  SELECT_CUSTOMER: 'order/customer',
  ORDER_V2: 'order',
};

export const routePaths: { [key: string]: string } = {
  pathNotDefined: '',
  unauthorized: '/unauthorized',
  error: '/error',
  errorWithType: '/error/:errorType',
  notFound: '/not-found',
  dummy: '/dummy',
  base: `${BASE_PATH_WITH_TXA}`,
  home: `${BASE_PATH_WITH_TXA}/${routeFragments.HOME}`,
  details: `${BASE_PATH_WITH_TXA}/${routeFragments.DETAILS}/`,
  accountBalance: `${BASE_PATH_WITH_TXA}/${routeFragments.DETAILS_ACCOUNT_BALANCE}`,
  invoices: `${BASE_PATH_WITH_TXA}/${routeFragments.INVOICES}/`,
  invoiceDetails: `${BASE_PATH_WITH_TXA}/${routeFragments.INVOICES}/:invoiceId`,
  confirmPayment: `${BASE_PATH_WITH_TXA}/${routeFragments.INVOICES}/:invoiceId/confirm-payment`,
  refunds: `${BASE_PATH_WITH_TXA}/${routeFragments.REFUNDS}/`,
  refundDetails: `${BASE_PATH_WITH_TXA}/${routeFragments.REFUNDS}/:refundId`,
  subscriptions: `${BASE_PATH_WITH_TXA}/${routeFragments.SUBSCRIPTIONS}/`,
  internalUsageSubscriptions: `${BASE_PATH_WITH_TXA}/${routeFragments.INTERNAL_USAGE_SUBSCRIPTIONS}/`,
  entitlement: `${BASE_PATH_WITH_TXA}/${routeFragments.SUBSCRIPTIONS}/:entitlementId`,
  catalog: `${BASE_PATH_WITH_TXA}/${routeFragments.CATALOG}/`,
  search: `${BASE_PATH_WITH_TXA}/${routeFragments.SEARCH}`,
  customerAddresses: `${BASE_PATH_WITH_TXA}/${routeFragments.CUSTOMER_ADDRESSES}`,
  customerAddressDetailsByCompany: `${BASE_PATH_WITH_TXA}/${routeFragments.CUSTOMER_ADDRESSES}/:companyName`,
  customerAddressDetailsById: `${BASE_PATH_WITH_TXA}/${routeFragments.CUSTOMER_ADDRESS_DETAIL}/:addressId`,
  billingProfileDetails: `${BASE_PATH_WITH_TXA}/${routeFragments.BILLING_PROFILES}/:billingProfileId`,
  cloudSite: `${BASE_PATH_WITH_TXA}/${routeFragments.CLOUD_SITE_PATH}/:cloudSiteId`,
  emailDetails: `${BASE_PATH_WITH_TXA}/${routeFragments.EMAIL_DETAILS_PATH}/:emailId`,
  orderDetails: `${BASE_PATH_WITH_TXA}/${routeFragments.ORDER_DETAILS_PATH}/:orderId`,
  importSubscription: `${BASE_PATH_WITH_TXA}/${routeFragments.IMPORT_SUBSCRIPTION_PAGE}`,
  quotes: `${BASE_PATH_WITH_TXA}/${routeFragments.QUOTES}`,
  ppcQuoteDetails: `${BASE_PATH_WITH_TXA}/${routeFragments.QUOTES}/:quoteId`,
  quotesMFA: '/quotes',
  quoteDetails: '/quotes/:id',
  partnerOnboarding: '/api-onboarding',
  manageToken: '/manage/:tokenId',
  addPaymentMethod: '/add-payment',
  order: `${BASE_PATH_WITH_TXA}/${routeFragments.ORDER}`,
  accessPending: '/access-pending',
  creditDetails: `${BASE_PATH_WITH_TXA}/${routeFragments.CREDIT_DETAILS_PATH}`,
  manageNotifications: `${BASE_PATH_WITH_TXA}/${routeFragments.SETTINGS}`,
  organisations: `${BASE_PATH_WITH_TXA}/${routeFragments.ORGANISATIONS}/`,
  organisationDetails: `${BASE_PATH_WITH_TXA}/${routeFragments.ORGANISATIONS}/:organisationId`,
  catalogDetails: `${BASE_PATH_WITH_TXA}/${routeFragments.CATALOG}/:productId`,
  uofSelectCustomer: `${BASE_PATH_WITH_TXA}/${routeFragments.SELECT_CUSTOMER}`,
  uofSelectBillingProfile: `${BASE_PATH_WITH_TXA}/${routeFragments.SELECT_CUSTOMER}/:customerName`,
  orderV2: `${BASE_PATH_WITH_TXA}/${routeFragments.ORDER_V2}/:billingProfileId`,
  cart: `${BASE_PATH_WITH_TXA}/${routeFragments.CART}`,
  dealRegistrations: `${BASE_PATH_WITH_TXA}/${routeFragments.DEAL_REGISTRATIONS}/`,
};

export const routeToRoutePathMapForInProductHelp = {
  home: 'home-page',
  details: 'account-details',
  creditDetails: 'credit-details',
  search: 'global-search',
  customerAddresses: 'customers-list',
  customerAddressDetailsByCompany: 'customer-details',
  customerAddressDetailsById: 'sold-to-address-details',
  billingProfileDetails: 'billing-profile-details',
  subscriptions: 'subscriptions-list',
  entitlement: 'subscription-details',
  invoiceDetails: 'invoice-details',
  invoices: 'invoices-list',
  orderDetails: 'order-details',
  order: 'monthly-order',
  catalog: 'catalog',
  quotes: 'quotes-list',
  ppcQuoteDetails: 'quote-details',
};

export const customRouteRedirectPath = {
  [routePaths.customerAddressDetailsByCompany]: routePaths.customerAddresses,
  [routePaths.customerAddressDetailsById]: routePaths.customerAddresses,
  [routePaths.orderDetails]: routePaths.details,
};

export const DEFAULT_PAGE_ROUTE = routePaths.home;
